// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__kySMa","insightsList":"newBusinessInsightsMenu_insightsList__22mMg","active":"newBusinessInsightsMenu_active__1z9-c"};